import React, { Suspense, lazy } from 'react';

const Header = lazy(() => import('./components/Header.js'));
const Services = lazy(() => import('./components/Services.js'));
const Artistas = lazy(() => import('./components/Artistas.js'));
const HeroSection = lazy(() => import('./components/HeroSection.js'));
const Horario = lazy(() => import('./components/Horario.js'));
const Tarifas = lazy(() => import('./components/Tarifas.js'));
const Contacto = lazy(() => import('./components/Contacto.js'));


function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Cargando...</div>}>
        <Header />
        <HeroSection />
        <Services />
        <Contacto />
        <Artistas />
        <Horario />
        <Tarifas />
      </Suspense>
    </div>
  );
}

export default App;